import { createFileRoute } from "@tanstack/react-router";
import FeaturedResourcesPage from "@/modules/resources/pages/featured";

export const Route = createFileRoute(
  "/(auth)/_headed/resources/_layout/featured"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <FeaturedResourcesPage />;
}
